// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-Jodb","spinner":"styles_spinner__nsGrF","empty":"styles_empty__q4PQI"};